import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, trackPageView } from '../../utils/analytics';

/**
 * SPA page views plus the restaurant screens guests actually land on.
 * Cart, menu, and item events fire from the route so every entry path is covered.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    trackPageView(path);

    const home = path.match(/^\/restaurants\/([^/]+)\/?$/);
    if (home) {
      trackEvent('view_restaurant', { restaurant_app: decodeURIComponent(home[1]) });
      return;
    }

    const menu = path.match(/^\/restaurants\/([^/]+)\/(menu|browse)\/?$/);
    if (menu) {
      trackEvent('view_item_list', {
        restaurant_app: decodeURIComponent(menu[1]),
        item_list_name: menu[2],
      });
      return;
    }

    const item = path.match(/^\/restaurants\/([^/]+)\/menu\/([^/]+)\/?$/);
    if (item) {
      trackEvent('view_item', {
        restaurant_app: decodeURIComponent(item[1]),
        item_id: decodeURIComponent(item[2]),
      });
      return;
    }

    const cart = path.match(/^\/restaurants\/([^/]+)\/cart\/?$/);
    if (cart) {
      trackEvent('begin_checkout', { restaurant_app: decodeURIComponent(cart[1]) });
    }
  }, [location.pathname, location.search]);

  return null;
}
